import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Backdrop, CircularProgress } from "@mui/material";
import { Button, Col, Popconfirm, Row, Table, TableProps, Typography } from "antd";
import { SorterResult } from "antd/es/table/interface";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { DeleteDevice, GetDeviceList, axiosErrorMessages } from "../../../../API/api";
import { useAppRole } from "../../../../API/RoleContext";
import AdminLayout from "../../../../component/AdminLayout";
import SearchBar from "../../../../component/Search";
import { customSortDirections } from "../../../../Utils/utils";
import AddEditDevice from "../components/AddEditDevice";
import axios, { AxiosError } from "axios";

interface DeviceItem {
    deviceId:number;
    key:number;
    deviceName:string;
    
  }
  const DeviceSettings = () => {
    const appRole = useAppRole();

    const [isLoading,setIsLoading] = useState<boolean>(false)
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isAddNewDevice,setIsAddNewDevice] = useState<boolean>(false)
    const [editData,setEditData] = useState({})
    const [isAdd,setIsAdd] = useState<boolean>(true)
    const [sortedInfo, setSortedInfo] = useState<SorterResult<DeviceItem>>({});
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState<DeviceItem[]>([]);
    const [deviceList,setDeviceList] = useState([])
    const [pagesize,setPageSize] = useState<number>(50)

    useEffect(()=>{
      fetchDeviceList()
    },[])
    useEffect(() => {
      if(searchText)
        filterData(searchText)
    },[deviceList])
    const fetchDeviceList = async () => {
      try {
        setIsLoading(true)
        const response = await GetDeviceList();
        const newData = response.data.map((device: any, index: number) => ({
          ...device,
          key: device.deviceTypeId,
        })

      );
      setDeviceList(newData)
      setIsLoading(false)

      } catch (error:any) {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
       
        setIsLoading(false)
      }
   
    }

    const handleSearch = (value:string) =>{
        setCurrentPage(1);
        setSearchText(value);
        filterData(value);
    }
    const handleAddNewDevice = () => {
        setIsAdd(true)
        setIsAddNewDevice(true)
    }
    const filterData = (searchText: string) => {
        if (!searchText) {
          setFilteredData([]);
        } else {
          const filtered = deviceList.filter((item: any) =>
            item.deviceType.toLowerCase().includes(searchText.toLowerCase())
          );
          setFilteredData(filtered);
        }
      };
    const handleDelete = (rowData:any) =>{ 
      setIsLoading(true)
      DeleteDevice(rowData)
                  .then((response:any)  =>  {
                    enqueueSnackbar("Deleted Successfully", {
                      variant: "success",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });

                    setIsLoading(false)
                    fetchDeviceList()
                  })
                  .catch((error:any)  =>  {
                  
                    enqueueSnackbar(error.response.data.errors.DeviceType[0], {
                      variant: "error",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });
                    setIsLoading(false)

                  })



    }
    const edit = (rowData:any) => { setIsAdd(false);setEditData(rowData); setIsAddNewDevice(true)}
    const handleClose = () => {setIsAddNewDevice(false) ; fetchDeviceList()}
    const handleChange: TableProps<DeviceItem>["onChange"] = (
  
        pagination,
        filters,
        sorter
      ) => {
        setSortedInfo(sorter as SorterResult<DeviceItem>);
        setCurrentPage(pagination.current || 1);
        setPageSize(pagination.pageSize ?? 50)
      };
    
   
    const columns = [
        {
          title: "No",
          dataIndex: "id",
          key: "id",
          width: "10%",
          render: (text: any, record: any, index: number) =>
            (currentPage - 1) * pagesize + index + 1,
        },
        {
          title: "Device Type",
          dataIndex: "deviceType",
          key: "deviceType",
          width: "40%",
          sorter: (a: any, b: any) => a.deviceType.localeCompare(b.deviceType),
          sortOrder: sortedInfo.columnKey === "deviceType" ? sortedInfo.order : null,
          render: (text: string) =><div>{text}</div>      ,
        },
        ...(appRole
          ? [
        {
          title: "Action",
          dataIndex: "action",
          width: "20%",
    
          render: (_: any, record: any) => {
            
            return  (
              <>
                {" "}

                <Typography.Link
  disabled={['Server', 'Desktop'].includes(record.deviceType)}
  onClick={() => edit(record)}
                >
                  <EditOutlined />
                </Typography.Link>
                <Popconfirm
                  title="Do you want to delete the device?"
                  onConfirm={() => handleDelete(record.key)}
                >
                  <Typography.Link
  disabled={['Server', 'Desktop'].includes(record.deviceType)}

                    className="delete-btn"
                  >
                    <DeleteOutlined />
                  </Typography.Link>
                </Popconfirm>
              </>
            );
          },
        }
      ]
      : []),
      ];
    return <>
        <AdminLayout>
        <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={isLoading}
  >
    <CircularProgress color="inherit" /></Backdrop>
          <div>
            <div className="employee-table-header ">
            <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px 0 16px"}}>
                <Col className="gutter-row" lg={12} sm={24}>
                  <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                    Device Settings
                  </h3>
                </Col>
                <Col className="gutter-row pm-search-flex" lg={{span: 10, offset: 2}} sm={24} xs={24} style={{ display: "flex"}}>
                  <SearchBar
                    width={"100%"}
                    onSearch={handleSearch}
                    placeholder={"Search Device"}
                  />
                  {appRole &&  <Button
                    onClick={handleAddNewDevice}
                    type="primary"
                    style={{ marginLeft: 10 }}
                    size="small"
                  >
                    Add New
                  </Button>}
                 
                </Col>
              </Row>
            </div>
            <div>
          
           
            </div>
  
              <Table
                sortDirections={customSortDirections}
                scroll={{ x: 1000, y: 450 }}
                className="status-list-admin"
                columns={columns}
                size='small'

                onChange={handleChange}
                pagination={{
                  current: currentPage,
                  showSizeChanger: true,
                  defaultPageSize: 50,
                }}
                rowClassName="editable-row"
                dataSource={searchText ? filteredData : deviceList}
              />

              {isAddNewDevice && <AddEditDevice isAdd={isAdd} editData={editData} handleClose={handleClose} />}
          
          </div>
        </AdminLayout>
    </>
}
export default DeviceSettings